/**
 * useLanguageSync Hook
 *
 * Synchronizes the i18n language with the HTML document.
 * - Updates HTML lang attribute when language changes
 *
 * Note: URL query parameter detection is handled by i18next's queryStringDetector
 * in config.ts. URL updates are handled by LanguageSwitcher when user explicitly
 * changes language.
 *
 * This hook should be used once at the app root level (e.g., in Layout).
 */

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Hook to synchronize i18n language with HTML document
 *
 * @example
 * ```tsx
 * function Layout() {
 *   useLanguageSync()
 *   return <Outlet />
 * }
 * ```
 */
export function useLanguageSync() {
  const { i18n } = useTranslation();

  // Update HTML lang attribute when language changes
  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);
}

export default useLanguageSync;
